import { render, staticRenderFns } from "./PortraitDetail.vue?vue&type=template&id=b615e92e&scoped=true&"
import script from "./PortraitDetail.vue?vue&type=script&lang=js&"
export * from "./PortraitDetail.vue?vue&type=script&lang=js&"
import style0 from "./PortraitDetail.vue?vue&type=style&index=0&id=b615e92e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b615e92e",
  null
  
)

export default component.exports